import * as React from 'react';

import SelectComponent, { SelectComponentProps } from 'src/modules/commons/inputs/select/Select.component';

interface SelectContainerProps {
  label?: string;
  value: string;
  placeholder?: string;
  handleChange: (value: string) => void;
  required?: boolean;
  addEmptyOption: boolean;
  className?: string;
  itemSet: { name: string; value: string; }[];
  width?: string;
}

export default class SelectContainer extends React.Component<SelectContainerProps> {

  private label: string;
  private placeholder: string;
  private len: string;

  constructor(props: SelectContainerProps) {
    super(props);

    this.label = props.label ? props.label : 'Selecciona';
    this.placeholder = props.placeholder ? props.placeholder : 'Selecciona un element';
    this.len = props.width ? props.width : 'col-md-4';
  }

  public onChange(value: string): void {
    this.props.handleChange(value);
  }

  public render(): React.ReactNode {
    return (
      <SelectComponent {...this.getComponentProps()}/>
    );
  }

  private getComponentProps(): SelectComponentProps {
    return {
      value: this.props.value,
      options: this.props.itemSet,
      handleChange: (value: string) => this.onChange(value),
      required: this.props.required ? this.props.required : false,
      addEmptyOption: this.props.addEmptyOption,
      label: this.label,
      placeholder: this.placeholder,
      className: this.props.className,
      width: this.len,
    };
  }
}



// WEBPACK FOOTER //
// ./src/modules/commons/inputs/select/Select.container.tsx